import React, { useEffect, useState } from 'react'
import tw from 'twin.macro'
import * as constants from '../consts/index'
import useWindowDimensions from '../helpers/useWindowDimensions'

const CategoryLabelTitle = tw.h1`tracking-wide text-base text-gray-700 font-semibold`
import { ReactComponent as SearchIcon } from '../../node_modules/feather-icons/dist/icons/search.svg'

const SearchFilterComponent = (props) => {
  const [query, setQuery] = useState('')

  const { width } = useWindowDimensions() || {}

  useEffect(() => {
    if (width < constants.mdWidth) {
      setQuery('')
    }
  }, [width])

  useEffect(() => {
    if (props.setSearchText) {
      const timeOutId = setTimeout(() => props.setSearchText(query), 500)
      return () => clearTimeout(timeOutId)
    }
  }, [query])

  return (
    <div className="mb-4">
      <div className="p-2 h-auto">
        <div className="mb-2">
          <CategoryLabelTitle>Filter</CategoryLabelTitle>
        </div>
        <div className="">
          <label className="relative text-gray-400 focus-within:text-gray-600 block">
            <input
              type="search"
              name="email"
              id="email"
              placeholder="Search..."
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              className="form-input rounded bg-gray-100 border border-gray-200 py-2 px-2 bg-gray-100 text-gray-700 appearance-none w-full block pr-8 focus:outline-none focus:border-green-500 focus:bg-white"
            ></input>
            <SearchIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer" />
          </label>
        </div>
      </div>
    </div>
  )
}

export default React.memo(SearchFilterComponent)
